module.exports = __webpack_public_path__ + "static/media/Avatars_Other-14.337dbb5e.png";